import { Alert, Button, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

export function ErrorNotice({ error, retry }) {
  if (!error) return null;
  return <Alert color="red" icon={<IconAlertCircle size={18} />} title="Something went wrong" role="alert">
    <Text size="sm">{error.message || 'Please try again.'}</Text>
    {retry && <Button mt="sm" size="xs" color="red" variant="light" onClick={retry}>Retry</Button>}
    {(error.status === 401 || error.reauthenticate) && <Button mt="sm" ml="xs" size="xs" component="a" href="/auth/google">Sign in again</Button>}
  </Alert>;
}
